/*!
 * Adopted from https://github.com/naoak/workerize-transferable
 */

export const MESSAGE_TYPE_RPC_TRANSFERABLE = 'RPC_transferable';
